exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-sample{margin-bottom:1rem;min-height:4rem;background-color:#f7f7f7;border-radius:4px}.grid-sample div{background-color:#8ea6af}.grid-sample div .col-sample{background-color:#eaeaea;height:4rem;padding:1rem 0;text-align:center}.grid-sample.no-gutters .col-sample{border:1px solid #c4ced1}.grid-sample-vertical{margin-bottom:1rem;height:12rem;background-color:#f7f7f7;border-radius:4px}.grid-sample-vertical div{background-color:#8ea6af}.grid-sample-vertical div .col-sample-vertical{background-color:#eaeaea;height:4rem;padding:1rem 0;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b1b8d59c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?outputStyle=expanded!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/routes/Grid.vue
// module id = pR4f
// module chunks = 1